import {Typed} from "app/stimulus/typed-stimulus";
import {ActionEvent, Controller} from "@hotwired/stimulus";
import {isActionEvent} from "app/stimulus/stimulus-utils";

export default class extends Typed(
    Controller<HTMLElement>, {
        targets: {
            answer26a: HTMLInputElement,
            optionalSection: HTMLElement,
        }
    }
)
{
    public connect(): void {
        this.setupOptionalSection();
    }

    public answerSelected(questionNumber: number, tag: string): void;
    public answerSelected(event: ActionEvent): void;
    public answerSelected(firstArg?: any, secondArg?: any): void {
        let questionNumber: number | undefined = undefined;
        let tag: string | undefined = undefined;
        if (typeof firstArg === 'number') {
            questionNumber = firstArg;

        }
        if (typeof secondArg === 'string') {
            tag = secondArg;
        }
        if (isActionEvent(firstArg)) {
            questionNumber = parseInt(firstArg.params.questionNumber);
            tag = firstArg.params.tag;
        }
        if (questionNumber === undefined || tag === undefined) {
            return;
        }
        if (questionNumber === 26) {
            this.setupOptionalSection();
        }
    }

    private setupOptionalSection(): void {
        if (!this.hasOptionalSectionTarget) {
            return;
        }
        let show = false;
        if (this.hasAnswer26aTarget && this.answer26aTarget.checked) {
            show = true;
        }
        show
            ? this.optionalSectionTarget.style.removeProperty('display')
            : this.optionalSectionTarget.style.setProperty('display', 'none');
    }
}
